import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
const relatedLinks = [{
  title: 'Kids Taekwondo',
  href: '/kids-taekwondo-classes-in-farmington-hills-michigan',
  description: 'Our main Kids Taekwondo landing page.'
}, {
  title: 'Mini Troopers (Ages 3-5)',
  href: '/mini-troopers',
  description: 'Preschool-friendly martial arts program.'
}, {
  title: 'Kids Classes',
  href: '/karate-kids-classes.html',
  description: "The core children's program at Storm."
}, {
  title: 'Family Classes',
  href: '/FamilyKarateClasses.html',
  description: 'Train together with your kids.'
}, {
  title: 'Programs Overview',
  href: '/Programs.html'
}, {
  title: 'Start a Trial Class',
  href: '/SignMeUp'
}];
export function KidsMartialArtsRelatedLinks() {
  return <section className="py-20 bg-off-white border-t border-subtle-gray" data-id="element-2138">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2139">
        <h2 className="text-3xl md:text-4xl text-ink text-center mb-12" data-id="element-2140">
          Related Classes & Programs
        </h2>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-2141">
          {relatedLinks.map(link => <Link key={link.href} to={link.href} className="group bg-paper border border-subtle-gray hover:border-storm-red rounded-2xl p-6 transition-all flex items-start justify-between gap-4" data-id="element-2142">
              <div data-id="element-2143">
                <p className="font-bold text-ink text-lg mb-1" data-id="element-2144">{link.title}</p>
                {link.description && <p className="text-sm text-gray-warm" data-id="element-2145">{link.description}</p>}
              </div>
              <ArrowRight className="w-5 h-5 text-storm-red shrink-0 mt-1 group-hover:translate-x-1 transition-transform" data-id="element-2146" />
            </Link>)}
        </div>
      </div>
    </section>;
}